let mock = false;
let baseURL = '//api.elfinbook.com/';
let redirectURL = '//www.elfinbook.com';
if (location.host == 'app.book.com') {
  // baseURL = '//api.elfinbook.test.hzqihui.cn';
  baseURL = '//api.book.com';
  redirectURL = '//www.elfinbook.test.hzqihui.cn';
}
// baseURL = '//api.book.com';

export { mock, baseURL, redirectURL };
